import React from "react";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import Card, { CardHeader } from "material-ui/Card";
import EditIcon from "material-ui-icons/Edit";
import IconButton from "material-ui/IconButton";
import Typography from "material-ui/Typography";

const AccountCostLimitsCard = props => {
  const { account, classes, costLimits, loadingCostLimits } = props;
  const costLimitEntries = Object.values(costLimits);
  const costLimitRows =
    costLimitEntries.length > 0 ? (
      costLimitEntries
        .filter(costLimit => costLimit.accountId === account.id)
        .map(costLimit => {
          return (
            <TableRow key={costLimit.id}>
              <TableCell>
                <span style={{ textTransform: "capitalize" }}>
                  {(costLimit.propertyType || "No type,") + " "}
                </span>
                {(costLimit.propertyKey &&
                  costLimit.propertyKey.split("|")[1]) ||
                  "No key"}
              </TableCell>
              <TableCell>{costLimit.hardLimit ? "yes" : "no"}</TableCell>
              <TableCell numeric>
                {costLimit.units === "dollars"
                  ? `$ ${costLimit.spent}`
                  : `${costLimit.spent} ${costLimit.units}`}
              </TableCell>
              <TableCell numeric>
                {costLimit.units === "dollars"
                  ? `$ ${costLimit.limit}`
                  : `${costLimit.limit} ${costLimit.units}`}
              </TableCell>
              <TableCell numeric>
                <IconButton
                  key="edit"
                  aria-label="Edit"
                  onClick={() => props.editCostLimit(costLimit.id)}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })
    ) : (
      <TableRow>
        <TableCell colSpan="4" style={{ textAlign: "center" }}>
          This Account does not have any limit set
        </TableCell>
      </TableRow>
    );

  const tableBody = loadingCostLimits ? (
    <TableRow>
      <TableCell style={{ textAlign: "center" }} colSpan="4">
        Loading...
      </TableCell>
    </TableRow>
  ) : (
    costLimitRows
  );

  return (
    <Card>
      <CardHeader
        title={
          <Typography type="title" gutterBottom className={classes.title}>
            Cost Limits
          </Typography>
        }
      />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Resource</TableCell>
            <TableCell>Hard Limit?</TableCell>
            <TableCell numeric>Spent</TableCell>
            <TableCell numeric>Maximum Limit</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>{tableBody}</TableBody>
      </Table>
    </Card>
  );
};

export default AccountCostLimitsCard;



// WEBPACK FOOTER //
// ./src/AccountCostLimitsCard.js